export interface BolParty {
  name: string
  address: string
  city_state_zip: string
  reference_id: string
}

export interface BolCustomerOrderLine {
  order_number: string
  qty: string
  weight: string
  pallet_slip: string
}

export interface BolCommodityLine {
  handling_unit_qty: string
  handling_unit_type: string
  package_qty: string
  package_type: string
  weight: string
  hazmat: boolean
  description: string
  nmfc: string
  freight_class: string
}

export type FreightChargeTerms = 'prepaid' | 'collect' | '3rd_party'
export type CodTerms = 'collect' | 'prepaid' | ''

export interface BolRequest {
  bol_number: string
  date: string
  shipper: BolParty
  consignee: BolParty
  third_party_bill_to: BolParty | null
  carrier_name: string
  trailer_number: string
  freight_charge_terms: FreightChargeTerms
  special_instructions: string
  customer_order_lines: BolCustomerOrderLine[]
  commodity_lines: BolCommodityLine[]
  grand_total: string
  cod_amount: string
  cod_terms: CodTerms
  liability_value: string
  liability_unit: string
  shipper_printed_name: string
  shipper_date: string
  carrier_printed_name: string
  carrier_date: string
}

export interface BolResponse {
  file_id: string
  pdf_url: string
}

export function blankParty(): BolParty {
  return { name: '', address: '', city_state_zip: '', reference_id: '' }
}

export function blankCustomerOrderLine(): BolCustomerOrderLine {
  return { order_number: '', qty: '', weight: '', pallet_slip: '' }
}

export function blankCommodityLine(): BolCommodityLine {
  return {
    handling_unit_qty: '', handling_unit_type: '', package_qty: '', package_type: '',
    weight: '', hazmat: false, description: '', nmfc: '', freight_class: '',
  }
}

export function blankBolRequest(): BolRequest {
  return {
    bol_number: '',
    date: new Date().toISOString().slice(0, 10),
    shipper: blankParty(),
    consignee: blankParty(),
    third_party_bill_to: null,
    carrier_name: '',
    trailer_number: '',
    freight_charge_terms: 'prepaid',
    special_instructions: '',
    customer_order_lines: [blankCustomerOrderLine()],
    commodity_lines: [blankCommodityLine()],
    grand_total: '',
    cod_amount: '',
    cod_terms: '',
    liability_value: '',
    liability_unit: '',
    shipper_printed_name: '',
    shipper_date: '',
    carrier_printed_name: '',
    carrier_date: '',
  }
}
